import { action } from 'mobx'
import type {
  DirectDepositTaxRefundDeliveryMethod,
  TaxRefundDeliveryMethod,
} from './TaxRefundDeliveryMethod'
import { BankAccountEditorViewModel } from './BankAccountEditorViewModel'
import { validationContext } from 'validx'
import { validateObject } from '@/utils/validx-util'

/**
 * View model for editing a direct deposit delivery method.
 */
export class DirectDepositDeliveryMethodEditorViewModel {
  /**
   * The type of the delivery method.
   */
  readonly type = 'DirectDeposit' as const

  /**
   * View model for editing the bank account details.
   */
  readonly bankAccountVm = new BankAccountEditorViewModel()

  /**
   * Validation context for the view model.
   */
  readonly validation = validationContext(this, {
    bankAccountVm: [validateObject()],
  })

  /**
   * Resets the state of the view model to that of the given
   * direct deposit delivery method, or defaults if none is specified.
   */
  @action.bound
  reset(method?: DirectDepositTaxRefundDeliveryMethod) {
    this.bankAccountVm.reset(method?.bankAccount)
  }

  /**
   * Maps the state of the VM to {@link DirectDepositTaxRefundDeliveryMethod}.
   */
  toDeliveryMethod(): TaxRefundDeliveryMethod {
    return {
      type: 'DirectDeposit',
      bankAccount: this.bankAccountVm.toBankAccountDetails(),
    }
  }
}
